import { format, isValid } from 'date-fns';
import { sub } from 'date-fns/esm';

const yesterdaydate = sub(new Date(), {
  days: 1,
});

const isValidDate = (
  dateTime?: string | number | Date | null
): dateTime is string | number | Date =>
  !!dateTime && isValid(new Date(dateTime));

export const getPrettierdate = (dateTime: string) => {
  if (!isValidDate(dateTime)) return '';
  const serverDate = format(new Date(dateTime), 'M/d/yyyy');
  if (serverDate === format(new Date(), 'M/d/yyyy')) return 'Today';
  else if (serverDate === format(new Date(yesterdaydate), 'M/d/yyyy'))
    return 'Yesterday';
  else return serverDate;
};

export const getTimeFormat = (dateTime: string) =>
  isValidDate(dateTime) ? format(new Date(dateTime), 'h:mm:ss a') : '';

export const getGlobalDateFormat = (dateTime: string) =>
  isValidDate(dateTime) ? format(new Date(dateTime), 'M/d/yyyy h:mm:ss a') : '';

export const dateFormat = (dateTime: string): string =>
  isValidDate(dateTime) ? format(new Date(dateTime), 'M/d/yyyy') : '';

export const dayMonthDateFormat = (dateTime: string) =>
  isValidDate(dateTime) ? format(new Date(dateTime), 'dd MMM yyyy HH:mm:ss') : '';

export const onFormatDate = (date?: Date): string => {
  return !date ? '' : dateFormat(date.toString());
};

export const dateConvertions = (date: string) => date.replaceAll('-', '/');

export const invoiceDateFormat = (dateTime: string) =>
  isValidDate(dateTime) ? format(new Date(dateTime), 'MM/dd/yyyy') : '';

export const formatDateTime = (dateTime: string) => {
  if (!isValidDate(dateTime)) return '';
  const isoCreatedDate = new Date(dateTime).toISOString().split('T')[0];
  return dateFormat(dateConvertions(isoCreatedDate));
};

export const getTimeFromDate = (dataTime: string) => {
  if (!isValidDate(dataTime)) return '';
  var d = new Date(dataTime);
  return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
};

export const validateFutureDate = (date: Date | null): boolean => {
  if (date) {
    const today = new Date();
    // Strip time part of today for comparison (e.g., if it's currently 3pm, we want to check only the date)
    today.setHours(0, 0, 0, 0); // Set time to midnight to only compare the date

    // Check if the date is in the future
    if (date > today) {
      return true;
    }
  }
  return false;
};
